// extracted by mini-css-extract-plugin
export default {"loanAgreementModal":"modal_loanAgreementModal__MmaHh","modal":"modal_modal__B8wMa","modalFooter":"modal_modalFooter__rspG0","closeModalBtn":"modal_closeModalBtn__AR-tO"};